
{
  "labels": {
    "form": "Form",
    "placeholder": "Select..."
  }
}
